import React from "react";
import s from "../PerformancePage.module.scss";
import { ConnectedInformationButton } from "../../../InformationButton";
import Loader from "../../../Loader/Loader";
import { MultiLineChart } from "../../../MultiLineChart/MultiLineChart";
import { Typography } from "@progress/kendo-react-common";
import { useTranslation } from "react-i18next";
import useSmallScreen from "@iliotech/data-wire/src/reactHooks/hooks/useSmallScreen";
import { IChartDataItemV2 } from "@iliotech/types";

interface IOwnProps {
  performanceBenchmarkName?: string;
  periodString: string;
  loading: boolean;
  performanceLineChartData: IChartDataItemV2[];
  generating?: boolean;
  height?: number;
  width?: number;
}

const { h6: H6, p: P } = Typography;

export const BenchmarkPerformanceChart = ({
  performanceBenchmarkName,
  periodString,
  loading,
  performanceLineChartData,
  generating,
  height,
  width,
}: IOwnProps) => {
  const { t } = useTranslation();
  const isMobile = useSmallScreen();
  const percentageValueFormatter = (v: number | undefined) =>
    v?.toFixed(2) + "%";

  return (
    <>
      <ConnectedInformationButton
        extraClass={"with-margin-bottom"}
        code={"performanceRelative"}
      >
        <H6
          style={{
            marginTop: generating ? "4px" : "0px",
          }}
          className={"element-title"}
        >
          {t("Performance vs Benchmark")}
        </H6>
      </ConnectedInformationButton>
      <P className={s.subtitle}>
        Your portfolio benchmark is {performanceBenchmarkName}.{" "}
        {!generating && "Click below to compare against other indices"}
      </P>

      <P className={"period-string"}>{periodString}</P>
      {loading ? (
        <Loader />
      ) : (
        <MultiLineChart
          height={height}
          width={width}
          generating={generating}
          legendProps={{
            hideLegend: true,
          }}
          maxDivisions={isMobile ? 15 : 20}
          tooltipProps={{
            hideTotal: true,
          }}
          valueFormatter={percentageValueFormatter!}
          data={performanceLineChartData}
          lineType="line"
        />
      )}
    </>
  );
};
